import { useState } from 'react';

/**
 * useWizardLoading Hook
 *
 * Manages loading and error states during wizard generation/submission.
 * Based on wizardFormWrapper.js state management.
 *
 * States:
 * - isGenerating: Wizard is being created
 * - isRunning: Wizard execution in progress
 * - loadingMessage: Display message for user
 * - error: Error message if generation fails
 */
export const useWizardLoading = () => {
  const [isGenerating, setIsGenerating] = useState(false);
  const [isRunning, setIsRunning] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState('');
  const [error, setError] = useState<string | null>(null);

  const setGenerating = (message: string) => {
    setIsGenerating(true);
    setIsRunning(false);
    setLoadingMessage(message);
    setError(null);
  };

  const setRunning = (message: string) => {
    setIsGenerating(false);
    setIsRunning(true);
    setLoadingMessage(message);
    setError(null);
  };

  const setErrorState = (errorMessage: string) => {
    setError(errorMessage);
    setIsGenerating(false);
    setIsRunning(false);
    setLoadingMessage('');
  };

  const reset = () => {
    setIsGenerating(false);
    setIsRunning(false);
    setLoadingMessage('');
    setError(null);
  };

  return {
    isGenerating,
    isRunning,
    loadingMessage,
    error,
    setGenerating,
    setRunning,
    setError: setErrorState,
    reset,
  };
};
